import { DataEntity } from './element.model';

export class GeoLocationState {
  deviceAvailable: boolean;
  trackingActive: boolean;
}
export class GeoLocationPosition {
  latitude: number;
  longitude: number;
  altitude: number;
}
export class MapActionArgument {
  actionId: string;
  feature: any;
  isFirstConstructionAction: boolean = false;
  payload?: any;
}
export enum MapActionIds {
  CREATE_OBJECT = 'CreateObject',
  CREATE_TICKET = 'CreateTicket',
  MARK_COORDINATE = 'Mark_Coordinate',
  CLEAR_MARKERS = 'Clear_Markers',
  CLEAR_SELECTIONS = 'Clear_Selection',
}
